import { defineComponent as _defineComponent } from 'vue'
import ListItemText from "@/components-UI/list/items/ListItemText.vue";
import SvgCopy from "@/assets/icons/copy2.svg";
import { useCopyText } from "@/utils/copyText";
import { computed } from "vue";

interface Props {
    value: string,
    isCopyOnClick?: boolean,
    isScrollable?: boolean,
    isFormatJson?: boolean,
    color?: 'red',
}

export default /*#__PURE__*/_defineComponent({
  __name: 'ListItemCode',
  props: {
    value: null,
    isCopyOnClick: { type: Boolean },
    isScrollable: { type: Boolean },
    isFormatJson: { type: Boolean },
    color: null
  },
  setup(__props: any) {

const props = __props as {
    value: string,
    isCopyOnClick?: boolean,
    isScrollable?: boolean,
    isFormatJson?: boolean,
    color?: 'red',
}



const copyValue = () => {
    if (!props.isCopyOnClick) return;
    useCopyText(props.value, 'Скопировано');
};

const formattedJson = computed(() => {
    const jsonString = JSON.stringify(JSON.parse(props.value), null, 4);

    return jsonString
        .replace(/\n/g, '<br>')
        .replace(/ /g, '&nbsp;');
});

return { __sfc: true,props, copyValue, formattedJson, ListItemText, SvgCopy }
}

})